import { TableColumnModel } from './table-settings.model';

export class CohortSettingsModel {
  constructor(
    public series: TableColumnModel[] = [],
    public dimensions: TableColumnModel[] = [],
    public breakdowns: TableColumnModel[] = [],
    public showInPercentage = true,
    public showFooterTotal = true,
    public cohortColors: [string, string] = ['#62BE7B', '#F8696B'],
    public twoColorCutPoint = 0,
  ) {}
}

export const DEFAULT_COHORT_PRIMARY = '#62BE7B';
export const DEFAULT_COHORT_SECONDARY = '#F8696B';
